import $ from "jquery";
import imagesLoaded from 'imagesloaded';

import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import CookiesConsent from "./components/cookies-consent";
import DeviceManager from "./utils/device-manager";
import TestimoniesSlider from "./components/testimonies-slider";
import StepsSlider from "./components/steps-slider";
import TextImageSlider from "./components/text-image-slider";
import Tabs from "./components/tabs";
import Headings from "./components/headings";
import FAQ from "./components/faq";
import HandheldMenu from "./components/handheld-menu";
import Accordions from "./components/accordions";
import ScrollInView from "./components/scroll-in-view";


import "./components/link-to-map";

$(function () {
	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");
			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// Browser detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		} else if (DeviceManager.isSafari()) {
			$html.addClass("safari");
		}
	};

	const instanciateComponents = () => {
		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);

		// Home slider component
		const $homesSliders = $(".homepage-slider");
		if ($homesSliders.length) {
			$homesSliders.each(function (index, el) {
				const homeSlider = new HomeSlider($(el));
			});
		}

		// Testimonies slider component
		const $testimoniesSliders = $(".testimonies_list");
		if ($testimoniesSliders.length) {
			$testimoniesSliders.each(function (index, el) {
				const testimoniesSlider = new TestimoniesSlider($(el));
			});
		}

		// Steps slider slider component
		const $stepsSliders = $(".steps-blocs-section__content");
		if ($stepsSliders.length) {
			$stepsSliders.each(function (index, el) {
				const stepsSlider = new StepsSlider($(el));
			});
		}

		// Text Image slider slider component
		const $textImageSliders = $(".text-image-column__container");
		if ($textImageSliders.length) {
			$textImageSliders.each(function (index, el) {
				const textImageSlider = new TextImageSlider($(el));
			});
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}

		// Evenement au scroll pour lancer l'animation des SVG
        const $listSectionSVG = $('.list-section__svg');
        if($listSectionSVG.length) {
            const $window = $(window);
			
            $window.on('scroll', function(e) {
                if($window.scrollTop() >= $listSectionSVG.offset().top - 500) {
                    const $paths = $listSectionSVG.find('path');

                    if($paths) {
						$paths.addClass('active');
                    }
				}
			});
		}

        // Cookie consent
        if(typeof tarteaucitron !== 'undefined' && tarteaucitron) {
            // Tarteaucitron cookie settings
            let tarteaucitronLang = 'fr';

            const cookiesConsent = new CookiesConsent(tarteaucitronLang);
        }
	};

	bootstrapApp();
	instanciateComponents();
});

